<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'Cobrança',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <form class="bs-example form-horizontal form-grv">
              <div class="bg-light lter b-b wrapper-md">
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <h1 class="font-thin h3">
                      Apreensão
                    </h1>
                  </div>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="clearfix">

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Pré-retirada</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">810000359 - Wallace Alonso Da Silva</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Dados da Cobrança
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Descricao</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">Diárias e Reboque para GRV 140140011</p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Vencimento</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">20/05/2019</p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Tipo</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">Normal</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Baixa
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Status</label>
                        <div class="col-sm-10">
                          <select class="form-control">
                            <option value="">Não Pago</option>
                            <option value="">Pago</option>
                            <option value="">Cancelado Pago</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Valor</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">2762,71</p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Desconto</label>
                        <div class="col-sm-10">
                          <input type="" name="" class="form-control">
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Valor pago</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">R$ 2762.71</p>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Falta pagar</label>
                        <div class="col-sm-10">
                          <p class="control-label text-left">R$ 0.00</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Tipo cobrancas
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                      <thead>
                        <tr>
                          <th colspan="2">Tipo</th>
                          <th>Valor</th>
                          <th>Referência</th>
                          <th>Opções</th>
                          <th>Cancelada</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Boleto</td>
                          <td>
                            <select class="form-control">
                              <option value="">Boleto</option>
                            </select>
                          </td>
                          <td>
                            <input type="" name="" class="form-control">
                          </td>
                          <td>
                            <div class="col-sm-9">
                              <input type="" name="" class="form-control">
                            </div>
                            <div class="col-sm-3">
                              <button class="btn btn-info btn-md m-l-xs">Consultar</button>
                            </div>
                          </td>
                          <td></td>
                          <td>
                            <label class="i-checks m-b-none">
                              <input type="checkbox" tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv">Salvar</button>
                        <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e continuar editando</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Cobranca.vue?43c8c07b